// This file defines types and interfaces for handling file uploads in the application.
// It was created here to reuse in fulfillment page document upload

import { VirtualFile } from '@schuettflix/react-components';

export type UploadedUploadFile = UploadFile & {
    status: 'uploaded';
    url: string;
    id: string;
};

export interface UploadFile {
    file: File | VirtualFile;
    progress: number;
    remotePath: string;
    status: 'pending' | 'uploading' | 'uploaded' | 'failed';
    error?: string;
    abortController?: AbortController;
    url?: string;
    id?: string;
}

export interface FileUploadConfig {
    allowedMimeTypes: string[];
    maxFileSizeInBytes: number;
}

export const DEFAULT_FILE_UPLOAD_CONFIG: FileUploadConfig = {
    allowedMimeTypes: ['image/jpeg', 'image/png', 'application/pdf'],
    maxFileSizeInBytes: 20 * 1024 * 1024, // 20MB
};
